// extracted by mini-css-extract-plugin
export default {"wired":"w66taC","spinner":"qJHs3V"};